<template>
 <div id="page-container" class="">
  <div class="content-wrap pb-5">
   <PbxDashboard
    v-model:selector="periodSelector"
    :dataSeriesCurrentMonth="dataSeriesCurrentMonth"
    @action="getDataFromElement()"
    @button-selector="(...args) => getSelectedButton(...args)"
    :extensions="extensions"
    :dataSeriesStacked="dataSeriesStacked"
    :urlType="urlType"
    :dataSeriesConcatenated="dataSeriesConcatenated"
    :periodSelector="this.periodSelector"
    @timeSelector="setTimeSelected($event)"
    @all-selected="allSelected($event)"
    :buttonSelected="this.buttonSelected"
    :textMonth="this.textMonth"
    :timeSelected="this.timeSelected"
   />
   <div v-show="extensions.length === 0">
    <EmptyStateDashboard />
   </div>
  </div>
 </div>
 <Loading
  v-model:active="isLoading"
  :can-cancel="true"
  :on-cancel="onCancel"
  :is-full-page="fullPage"
 />
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import PbxDashboard from "../../components/PBX/PbxDashboard.vue";
import EmptyStateDashboard from "../../components/PBX/EmptyStateDashboard.vue";

export default {
 props: ["urlType"],
 components: {
  EmptyStateDashboard,
  Loading,
  PbxDashboard,
 },
 data() {
  return {
   isLoading: false,
   fullPage: true,
   periodSelector: undefined,
   dataSeriesCurrentMonth: [],
   extensions: [],
   dataSeriesStacked: [],
   dataSeriesConcatenated: [],
   timeSelected: [],
   isAllSelected: "",
   buttonSelected: "month",
   textMonth: "",
   data: undefined,
  };
 },
 methods: {
  setTimeSelected(event) {
   this.timeSelected = event;
  },
  allSelected(val) {
   this.isAllSelected = val;
  },
  getSelectedButton(...args) {
   this.buttonSelected = args[0];
   this.textMonth = args[1];
  },
  async getPbxData(stringOfElements, period, type) {
   try {
    const res = await axios.get(
     `${this.$cookie.getCookie("API")}/api/v1/pbxData/${
      this.hostName
     }/originDetails?&elements=${stringOfElements}&days=${period}&type=${type}`,
     {
      headers: {
       Authorizations: `Bearer ${localStorage.getItem("token")}`,
      },
     }
    );
    console.log(
     "file: ExpertStatisticsOriginDetail.vue ~ line 89 ~ getPbxData ~ res.data",
     res.data
    );
    return res.data;
   } catch (error) {
    this.errorHandling(error);
    const status = error.response.status;
    this.$emit("setLoading", false);
    if (error.response.status === 500) {
     const msg = this.$t("error500");
     this.$router.push({
      name: "Error",
      query: { status, msg },
     });
    }
   }
  },
  async getDataFromElement() {
   this.$store.dispatch("pbxElementType", this.urlType);

   let period = this.currentMonthAndYearForPbx;
   let type = undefined;
   this.dataSeriesCurrentMonth = [];
   let arrayOfElements = [];
   let stringOfElements = "";
   this.extensions.length = 0;
   let res = undefined;

   if (this.periodSelector) {
    period = this.periodSelector;
   }

   if (this.pbxElements && this.pbxElements.length > 0) {
    this.$emit("setLoading", true);

    this.pbxElements.forEach((element, index) => {
     let elementValue = element;
     if (typeof elementValue === "object") {
      for (let index = 0; index < elementValue.length; index++) {
       const element = elementValue[index];
       arrayOfElements.push(element);
      }
     } else {
      arrayOfElements.push(element);
     }
    });

    arrayOfElements = [...new Set(arrayOfElements)];

    stringOfElements = String(arrayOfElements[0]);

    for (let index = 1; index < arrayOfElements.length; index++) {
     stringOfElements = stringOfElements + "," + String(arrayOfElements[index]);
    }

    let obj = {};
    let objConcat = {};
    let dataObj = {};
    let dataObjSerie = [];

    type = this.urlType;

    res = await this.getPbxData(stringOfElements, period, type);
    this.data = res;

    this.dataSeriesCurrentMonth = [];
    let keys = [];
    let objectKeyToGet = "";
    let timeSelectedIsHour = false;
    let timeSelectedIsQuarter = false;
    obj["data"] = [];

    if (this.timeSelected.length > 0) {
     if (this.timeSelected[0].slice(-2) === "00" && this.timeSelected[1].slice(-2) === "00") {
      timeSelectedIsHour = true;
     } else {
      timeSelectedIsQuarter = true;
     }
    }
    if (timeSelectedIsHour) {
     keys = Object.keys(res.sum_quarter_hourly);
     objectKeyToGet = "sum_quarter_hourly";
    } else if (timeSelectedIsQuarter) {
     keys = Object.keys(res.sum_quarter_hourly);
     objectKeyToGet = "sum_quarter_hourly";
    } else {
     keys = Object.keys(res.sum_period);
     objectKeyToGet = "sum_period";
    }

    if (keys.length > 0) {
     let dataObj = {};
     let dataObjSerie = {};

     const originElements = this.getAllOriginElementsFromKey(keys);

     for (let arrIndex = 0; arrIndex < arrayOfElements.length; arrIndex++) {
      let elementFromArray = arrayOfElements[arrIndex];

      obj = {};
      dataObj = {};

      let elementHasKey = false;

      for (let index = 0; index < keys.length; index++) {
       let splitElement = keys[index].split(":");
       if (splitElement[1] == arrayOfElements[arrIndex]) {
        elementHasKey = true;
       }
      }
      if (elementHasKey) {
       let top10Array = this.getTop10(keys, objectKeyToGet, arrayOfElements[arrIndex], res);

       if (objectKeyToGet === "sum_hourly") {
        top10Array = this.getTop10Hour(
         keys,
         objectKeyToGet,
         arrayOfElements[arrIndex],
         res,
         originElements
        );
       }

       if (objectKeyToGet === "sum_quarter_hourly") {
        top10Array = this.getTop10QuarterHour(
         keys,
         objectKeyToGet,
         arrayOfElements[arrIndex],
         res,
         originElements
        );
       }

       if (objectKeyToGet === "sum_hourly") {
        obj = this.generateDataForHourlyCharts(top10Array, elementFromArray, res);
       } else if (objectKeyToGet === "sum_quarter_hourly") {
        obj = this.generateDataForHourlyCharts(top10Array, elementFromArray, res);
       } else if (objectKeyToGet === "sum_period") {
        obj = this.generateDataForPeriodCharts(top10Array, res, elementFromArray, objectKeyToGet);
       } else {
        obj = this.generateDataForAllCharts(
         top10Array,
         res,
         elementFromArray,
         objectKeyToGet,
         period
        );
       }
      } else {
       dataObjSerie = 0;
       dataObj["No_data"] = { dataObjSerie };
       obj["data"] = dataObj;
       obj["name"] = arrayOfElements[arrIndex] + " - " + res.map[arrayOfElements[arrIndex]];
      }
      this.dataSeriesCurrentMonth.push(obj);
      this.extensions.splice(arrIndex, 1, obj["name"]);
     }

     this.dataSeriesConcatenated = [];
     objConcat = {};

     let top10ArrayCons = this.getTop10(keys, objectKeyToGet, "cons", res);

     if (objectKeyToGet === "sum_hourly") {
      top10ArrayCons = this.getTop10Hour(keys, objectKeyToGet, "cons", res, originElements);
     } else if (objectKeyToGet === "sum_quarter_hourly") {
      top10ArrayCons = this.getTop10QuarterHour(keys, objectKeyToGet, "cons", res, originElements);
     }

     this.generateConsolidatedData(top10ArrayCons, res, objectKeyToGet, period);
    } else {
     for (let arrIndex = 0; arrIndex < arrayOfElements.length; arrIndex++) {
      obj = {};
      dataObjSerie = 0;
      dataObj["No_data"] = { dataObjSerie };
      obj["data"] = dataObj;
      obj["name"] = arrayOfElements[arrIndex] + " - " + res.map[arrayOfElements[arrIndex]];
      this.extensions.splice(arrIndex, 1, obj["name"]);
      this.dataSeriesCurrentMonth.push(obj);
     }
     this.dataSeriesConcatenated = [];
     obj = {};
     dataObjSerie = 0;
     dataObj["No_data"] = { dataObjSerie };
     obj["data"] = dataObj;
     obj["name"] = "cons";
     this.dataSeriesConcatenated.push(obj);
    }

    this.$emit("setLoading", false);
   } else {
    this.dataSeriesCurrentMonth.length = 0;
    this.dataSeriesConcatenated.length = 0;
   }
   this.$emit("setLoading", false);
  },
  getTop10(keys, objectKeyToGet, element, data) {
   let array = [];
   for (var el in data[objectKeyToGet]) {
    let splitEl = el.split(":");
    if (splitEl[1] == element) {
     array.push([el, data[objectKeyToGet][el]]);
    }
   }
   array.sort(function (a, b) {
    return b[1] - a[1];
   });
   array = array.slice(0, 10);
   return array;
  },
  getTop10Hour(keys, objectKeyToGet, element, data, originElements) {
   let array = [];
   let obj = {};
   let dataObj = {};
   let elementValue = 0;
   let rangeOfHours = [];
   let rangeOfHoursLenght =
    parseInt(this.timeSelected[1].slice(0, 2)) - parseInt(this.timeSelected[0].slice(0, 2));
   let firsHour = (
    "0" +
    (parseInt(this.timeSelected[0].slice(0, 2)) + parseInt(this.hostTimeZone))
   ).slice(-2);

   for (let index = 0; index <= rangeOfHoursLenght; index++) {
    rangeOfHours.push(("0" + (parseInt(firsHour) + index)).slice(-2));
   }
   for (let index = 0; index < originElements.length; index++) {
    elementValue = 0;
    const originElement = originElements[index];
    for (var el in data[objectKeyToGet]) {
     let splitEl = el.split(":");
     if (splitEl[1] == element) {
      if (splitEl[4] === originElement) {
       if (
        parseInt(rangeOfHours[0]) <= parseInt(splitEl[2].slice(-2)) &&
        parseInt(splitEl[2].slice(-2)) <= parseInt(rangeOfHours[rangeOfHours.length - 1]) - 1
       ) {
        elementValue = elementValue + data[objectKeyToGet][el];
        dataObj[`${splitEl[3]}-${splitEl[4]}`] = elementValue;
       }
       obj["data"] = dataObj;
      }
     }
    }
   }

   Object.keys(obj.data).forEach((el) => {
    array.push([el, obj.data[el]]);
   });

   array.sort(function (a, b) {
    return b[1] - a[1];
   });

   array = array.slice(0, 10);

   return array;
  },
  getTop10QuarterHour(keys, objectKeyToGet, element, data, originElements) {
   let array = [];
   let obj = {};
   let dataObj = {};
   let elementValue = 0;
   let firsQuarterHour =
    ("0" + (parseInt(this.timeSelected[0].slice(0, 2)) + parseInt(this.hostTimeZone))).slice(-2) +
    this.timeSelected[0].slice(-2);
   let lastQuarterHour =
    ("0" + (parseInt(this.timeSelected[1].slice(0, 2)) + parseInt(this.hostTimeZone))).slice(-2) +
    this.timeSelected[1].slice(-2);

   for (let index = 0; index < originElements.length; index++) {
    elementValue = 0;
    const originElement = originElements[index];
    for (var el in data[objectKeyToGet]) {
     let splitEl = el.split(":");
     if (splitEl[1] == element) {
      let quarterHourlyElementSlice = splitEl[2].slice(-4);
      if (splitEl[3] === originElement) {
       if (
        parseInt(firsQuarterHour) <= parseInt(quarterHourlyElementSlice) &&
        parseInt(quarterHourlyElementSlice) < parseInt(lastQuarterHour)
       ) {
        elementValue = elementValue + data[objectKeyToGet][el];
        dataObj[`${splitEl[3]}`] = elementValue;
       }
       obj["data"] = dataObj;
      }
     }
    }
   }

   Object.keys(obj.data).forEach((el) => {
    array.push([el, obj.data[el]]);
   });

   array.sort(function (a, b) {
    return b[1] - a[1];
   });

   array = array.slice(0, 10);

   return array;
  },
  generateDataForHourlyCharts(arr, elementFromArray, data) {
   let obj = {};
   let dataObj = {};
   let dataObjSerie = {};
   let elementName = data.map[elementFromArray];
   obj["name"] = elementFromArray + " - " + elementName;
   for (let index = 0; index < arr.length; index++) {
    const element = arr[index];
    dataObjSerie = element[1];
    dataObj[element[0]] = { dataObjSerie };
    obj["data"] = dataObj;
   }
   return obj;
  },
  generateDataForPeriodCharts(keys, res, elementFromArray, objectKeyToGet) {
   let obj = {};
   let dataObj = {};
   let dataObjSerie = {};
   keys.forEach((element, index) => {
    let splitElement = element[0].split(":");
    let label = splitElement[3];
    let elementName = "";
    elementName = res.map[splitElement[1]];
    if (splitElement[1] == elementFromArray) {
     obj["name"] = splitElement[1] + " - " + elementName;
     dataObjSerie = res[objectKeyToGet][element[0]];
     dataObj[label] = { dataObjSerie };
     obj["data"] = dataObj;
    }
   });
   return obj;
  },
  generateDataForAllCharts(keys, res, elementFromArray, objectKeyToGet, period) {
   let obj = {};
   let dataObj = {};
   let dataObjSerie = {};
   keys.forEach((element, index) => {
    let splitElement = element[0].split(":");
    let label = splitElement[3] + "-" + splitElement[4];
    let elementName = "";
    elementName = res.map[splitElement[1]];
    if (splitElement[2] === period) {
     if (splitElement[1] == elementFromArray) {
      obj["name"] = splitElement[1] + " - " + elementName;
      dataObjSerie = res[objectKeyToGet][element[0]];
      dataObj[label] = {
       dataObjSerie,
      };
      obj["data"] = dataObj;
     }
    }
   });
   return obj;
  },
  generateConsolidatedData(keys, res, objectKeyToGet, period) {
   this.dataSeriesConcatenated = [];
   let objConcat = {};
   let elementFromArray = "cons";
   if (objectKeyToGet === "sum_hourly") {
    objConcat = this.generateDataForHourlyCharts(keys, elementFromArray, res);
   } else if (objectKeyToGet === "sum_quarter_hourly") {
    objConcat = this.generateDataForHourlyCharts(keys, elementFromArray, res);
   } else if (objectKeyToGet === "sum_period") {
    objConcat = this.generateDataForPeriodCharts(keys, res, elementFromArray, objectKeyToGet);
   } else {
    objConcat = this.generateDataForAllCharts(keys, res, elementFromArray, objectKeyToGet, period);
   }
   this.dataSeriesConcatenated.push(objConcat);
  },
  getAllOriginElementsFromKey(keys) {
   let arrayOfElements = [];
   keys.forEach((element, index) => {
    let splitEl = element.split(":");
    arrayOfElements.push(splitEl[3]);
   });
   arrayOfElements = [...new Set(arrayOfElements)];
   return arrayOfElements;
  },
 },
 mounted() {
  if (!this.pbxElements || this.pbxElements.length == 0) {
   this.dataSeriesCurrentMonth.length = 0;
   this.dataSeriesConcatenated.length = 0;
  }
  if (!this.periodSelector) {
   this.periodSelector = this.currentMonthAndYearForPbx;
  }
  if (this.pbxPeriodSelected) this.periodSelector = this.pbxPeriodSelected;

  if (this.pbxElementType !== this.urlType) this.$store.dispatch("pbxElements", null);
 },

 computed: {
  ...mapGetters([
   "account",
   "pbxElements",
   "pbxTimeSelected",
   "hostName",
   "hostTimeZone",
   "pbxElementType",
   "pbxPeriodSelected",
  ]),
  currentMonthAndYearForPbx() {
   let options = { month: "short" };
   let month = String("0" + (new Date().getMonth() + 1)).slice(-2);
   let formattedMonth = new Intl.DateTimeFormat("fr-FR", options).format(month).slice(0, -2);
   this.textMonth = formattedMonth;
   let year = new Date().getFullYear();
   return String(year) + String(month);
  },
 },
 watch: {
  periodSelector: function (val) {
   this.getDataFromElement();
  },
  timeSelected: function (val) {
   this.getDataFromElement(true);
  },
 },
};
</script>

<style>
#page-container {
 position: relative;
 min-height: 97%;
}
#content-wrap {
 padding-bottom: 2rem; /* Footer height */
}
#footer {
 position: absolute;
 bottom: 0;
 width: 100%;
 height: 2.5rem; /* Footer height */
}
</style>
